import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = { class: "card-toolbar" }
const _hoisted_3 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_adjust_balance"
}
const _hoisted_4 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card pt-4 ${_ctx.cardClasses}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-title" }, [
        _createElementVNode("h2", { class: "fw-bolder" }, "Credit Balance")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, {
              src: "/media/icons/duotune/art/art005.svg",
              "aria-hidden": "true"
            })
          ]),
          _cache[0] || (_cache[0] = _createTextVNode(" Adjust Balance ", -1))
        ])
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-body pt-0" }, [
      _createElementVNode("div", { class: "fw-bolder fs-2" }, [
        _createTextVNode(" $32,487.57 "),
        _createElementVNode("span", { class: "text-muted fs-4 fw-bold" }, "USD"),
        _createElementVNode("div", { class: "fs-7 fw-normal text-muted" }, " Balance will increase the amount due on the customer's next invoice. ")
      ])
    ], -1))
  ], 2))
}